if (!customElements.get('letter-block')) {
  class LetterBlock extends HTMLElement {
    static MOBILE_BREAKPOINT = 750;

    connectedCallback() {
      this.mediaQuery = window.matchMedia(`(min-width: ${LetterBlock.MOBILE_BREAKPOINT}px)`);
      this.boundUpdate = this.updateScale.bind(this);

      this.mediaQuery.addEventListener('change', this.boundUpdate);
      this.resizeObserver = new ResizeObserver(this.boundUpdate);
      this.resizeObserver.observe(this);

      this.updateScale();
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.boundUpdate);
      this.resizeObserver?.disconnect();
    }

    updateScale() {
      if (!this.mediaQuery.matches) {
        this.style.removeProperty('--letter-illustration-scale');
        return;
      }

      const contentWidth = Number(this.dataset.contentWidth);
      const illustrationWidth = Number(this.dataset.illustrationWidth);

      if (!contentWidth || !illustrationWidth) {
        return;
      }

      const horizontalPadding = Number(this.dataset.horizontalPadding) || 0;
      const widthPercent = Number(this.dataset.widthPercent) || 100;
      const viewportPadding = 16;
      const parentWidth = this.parentElement?.getBoundingClientRect().width ?? window.innerWidth;
      const availableWidth = (parentWidth * widthPercent) / 100 - horizontalPadding * 2;
      const illustrationSpace = Math.max(availableWidth - contentWidth, 0);
      let scale = Math.min(1, Math.max(illustrationSpace / illustrationWidth, 0.4));

      this.style.setProperty('--letter-illustration-scale', String(scale));

      const illustrations = this.querySelectorAll('[class*="ai-letter-illustration-"]');

      if (!illustrations.length) {
        return;
      }

      let minLeft = Infinity;
      let maxRight = -Infinity;

      for (const illustration of illustrations) {
        const rect = illustration.getBoundingClientRect();
        minLeft = Math.min(minLeft, rect.left);
        maxRight = Math.max(maxRight, rect.right);
      }

      const overflowLeft = Math.max(0, viewportPadding - minLeft);
      const overflowRight = Math.max(0, maxRight - (window.innerWidth - viewportPadding));
      const blockWidth = this.getBoundingClientRect().width;

      if ((overflowLeft > 0 || overflowRight > 0) && blockWidth > 0) {
        const correctedScale = scale * ((blockWidth - overflowLeft - overflowRight) / blockWidth);

        scale = Math.max(correctedScale, 0.4);
        this.style.setProperty('--letter-illustration-scale', String(scale));
      }
    }
  }

  customElements.define('letter-block', LetterBlock);
}
